import axios from 'axios';

// ⭐ HTTPS로 변경!
const API_BASE_URL = process.env.NODE_ENV === 'production'
	? 'https://api.weartoday.kr/api'  // ← http → https
	: 'http://localhost:8000/api';

const MEDIA_BASE_URL = process.env.NODE_ENV === 'production'
	? 'https://api.weartoday.kr/media'  // ← http → https
	: 'http://localhost:8000/media';

console.log('🔧 현재 환경:', process.env.NODE_ENV);
console.log('🔧 API URL:', API_BASE_URL);
console.log('🔧 MEDIA URL:', MEDIA_BASE_URL);

const api = axios.create({
	baseURL: API_BASE_URL,
	headers: {
		'Content-Type': 'application/json',
	},
});

api.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem('access_token');
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

export const getProducts = async (page = 1, categoryId = null) => {
	try {
		const params = { page };
		if (categoryId) {
			params.category = categoryId;
		}
		
		console.log('📦 상품 요청:', params);
		
		const response = await api.get('/products/products/', { params });
		
		console.log('✅ API 응답:', response.data);
		
		return {
			results: response.data.results || [],
			count: response.data.count || 0,
			total_pages: response.data.total_pages || 0,
			current_page: response.data.current_page || 1,
			next: response.data.next,
			previous: response.data.previous
		};
	} catch (error) {
		console.error('❌ 상품 목록 조회 실패:', error);
		return {
			results: [],
			count: 0,
			total_pages: 0,
			current_page: 1,
			next: null,
			previous: null
		};
	}
};

export const getProductById = async (id) => {
	try {
		const response = await api.get(`/products/products/${id}/`);
		console.log('✅ 상품 상세:', response.data);
		return response.data;
	} catch (error) {
		console.error('❌ 상품 상세 조회 실패:', error);
		throw error;
	}
};

export const getCategories = async () => {
	try {
		const response = await api.get('/products/categories/');
		console.log('✅ 카테고리:', response.data.length, '개');
		return response.data;
	} catch (error) {
		console.error('❌ 카테고리 조회 실패:', error);
		return [];
	}
};

export const getWishlist = async () => {
	try {
		const response = await api.get('/products/wishlist/');
		return response.data;
	} catch (error) {
		console.error('❌ 찜하기 목록 조회 실패:', error);
		throw error;
	}
};

export const addToWishlist = async (productId) => {
	try {
		const response = await api.post('/products/wishlist/', {
			product: productId
		});
		return response.data;
	} catch (error) {
		console.error('❌ 찜하기 추가 실패:', error);
		throw error;
	}
};

export const removeFromWishlist = async (wishlistId) => {
	try {
		const response = await api.delete(`/products/wishlist/${wishlistId}/`);
		return response.data;
	} catch (error) {
		console.error('❌ 찜하기 삭제 실패:', error);
		throw error;
	}
};

export const toggleWishlist = async (productId) => {
	try {
		const response = await api.post('/products/wishlist/toggle/', {
			product: productId
		});
		return response.data;
	} catch (error) {
		console.error('❌ 찜하기 토글 실패:', error);
		throw error;
	}
};

export const checkWishlist = async (productId) => {
	try {
		const response = await api.get(`/products/wishlist/check/?product=${productId}`);
		return response.data;
	} catch (error) {
		console.error('❌ 찜 여부 확인 실패:', error);
		return { is_wished: false };
	}
};

export { API_BASE_URL, MEDIA_BASE_URL };
export default api;
// ← 마지막 줄 "c" 삭제!